/* eslint-disable react/no-unused-prop-types */
import {
    Space,
    Button,
    notification,
    PageHeader,
    Typography,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { FC, useState } from 'react';
import { get } from 'lodash';

import DriverCard from '../DriverCard';
import Status from '../Status';
import { addDriver } from '../../api/drivers.api';
import { useWorkspaceStore } from '../../store/workspace.store';
import { IDriver } from '../../interfaces/driver.interface';

interface SendInvitationProps {
    driverData: Partial<IDriver>;
    previousStep: () => void;
}

const { Title } = Typography;

const SendInvitation: FC<SendInvitationProps> = ({ driverData, previousStep }) => {
    const { t: td } = useTranslation('drivers', { keyPrefix: 'DRIVERS' });
    const { t: ta } = useTranslation('shared', { keyPrefix: 'ACTIONS' });

    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState(false);

    const workspace = useWorkspaceStore((state) => state.data);

    const openStatus = () => setStatus(true);
    const closeStatus = () => setStatus(false);

    const onFinish = () => {
        setLoading(true);
        const payload = {
            ...driverData,
            smallFleetID: workspace?._id,
        };
        addDriver(payload).then(() => {
            openStatus();
        }).catch((error: any) => {
            const message = get(error, 'response.data.message');
            notification.error({
                message: td('DRIVER_NO_ADDED'),
                description: message,
            });
        }).finally(() => setLoading(false));
    };

    return (
        <Space direction="vertical" size={24} style={{ width: '100%' }}>
            <PageHeader
                title={(
                    <Title level={5} style={{ marginBottom: 0 }}>
                        {td('CONFIRMATION')}
                    </Title>
                )}
                onBack={() => previousStep()}
                extra={(
                    <Button
                        type="primary"
                        size="small"
                        loading={loading}
                        onClick={() => onFinish()}
                    >
                        {ta('FINALIZE')}
                    </Button>
                )}
            />

            <Status
                visible={status}
                onClose={closeStatus}
                type="SUCCESS"
                topic={td('DRIVER_ADDED')}
                message={td('SEND_INVITATION_SUCCESS')}
                path="/drivers"
                action={td('GO_TO_DRIVERS')}
            />

            <DriverCard driver={driverData as IDriver} />
        </Space>
    );
};

export default SendInvitation;
